document.addEventListener('click', e => {
	const btn = e.target.closest('.plans__open-modal');
	if (!btn) return;

	const modal = document.getElementById(btn.dataset.modalTarget);
	if (!modal) return;

	const table = modal.querySelector('.plans__container-card-table');
	const title = modal.querySelector('.plans__container-card-table-title');

	const rows = JSON.parse(btn.dataset.table || '[]');

	const wrapper = document.createElement('div');
	wrapper.className = 'plans__container-card-table-wrapper';

	title.textContent = btn.dataset.title;

	table.innerHTML = rows.map(r => `
		<div class="plans__container-card-table-row">
			<div class="plans__container-card-table-age">${r.age_group}</div>
			<div class="plans__container-card-table-value">${r.value}</div>
		</div>
	`).join('');

	title.replaceWith(wrapper);
	wrapper.append(title, table);
});
